<script lang="ts" setup>
import type { Annotation, DocumentSourceIdentifier } from '@sancare-commons/types/health-data'
import { computed, type Ref, ref } from 'vue'

import { filterStructuredDocument } from '../../components/health-data/utils'
import OcticonButton from '../OcticonButton.vue'

const props = defineProps<{
  annotations: Annotation[]
  highlightedAnnotationIds: number[]
}>()

const emit = defineEmits<{
  (e: 'show-source', documentSource: DocumentSourceIdentifier): void
}>()

const filtering = ref(null) as Ref<string>
const filteringOptions = {
  threshold: 0.49,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['namedEntityName', 'value'],
}
const filteredAnnotations = computed(() =>
  filterStructuredDocument(props.annotations, filtering.value, filteringOptions),
)
const sortedAnnotations = computed(() => {
  return filteredAnnotations.value.slice().sort((a, b) => a.namedEntityName.localeCompare(b.namedEntityName))
})
</script>

<template>
  <div>
    <div class="card-body row">
      <h1 class="report-title col">
        Annotations
      </h1>
      <div class="col-auto form-group">
        <input
          v-model="filtering"
          type="text"
          placeholder="Filtrage rapide"
          class="form-control col-auto"
        >
      </div>
    </div>
    <div class="card-body table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Entité nommée</th>
            <th>Valeur</th>
            <th>Unité</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="annotation in sortedAnnotations"
            :key="annotation.id"
            :class="{ 'hinted-line-highlighted': highlightedAnnotationIds.includes(annotation.id) }"
          >
            <td>{{ annotation.namedEntityName }}</td>
            <td>{{ annotation.value }}</td>
            <td>{{ annotation.unit ?? '-' }}</td>
            <td>
              <Octicon-button
                v-if="annotation.documentSourceIdentifier"
                octicon-name="hubot"
                custom-class="icon-link"
                title="Voir le document d'origine"
                :width="20"
                :height="20"
                @click="emit('show-source', annotation.documentSourceIdentifier)"
              />
            </td>
          </tr>
          <tr v-if="!sortedAnnotations.length">
            Aucune annotation ne correspond au filtre "{{ filtering }}"
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
